import React, { useState } from 'react';
import { Form, Button, Typography, Card, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';
import { AuthAPI } from '../../api/auth-api';
import styles from '../../styles/login.module.scss';
import Alert from 'antd/es/alert/Alert';
import Input from '../../components/elements/input/Input';

const { Title } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const from = location.state?.from?.pathname || '/korisnici';

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    email: '',
    password: '',
  });

  const handleOnChange = (e) => {
    const { value, name } = e.target;

    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleLogin = async () => {
    const { email, password } = form;

    if (!email || !password) {
      setError('Molimo unesite email i lozinku.');
      return;
    }

    setLoading(true);

    let error = null;

    const { data, success } = await AuthAPI.login({ email, password });

    if (!success || !data || !data?._id || !data?.token) {
      error = 'Neuspešna prijava. Proverite kredencijale.';
    }

    if (error) {
      setError(error);
    } else {
      const { token, ...rest } = data;
      const userObject = { ...rest };

      localStorage.setItem('user', JSON.stringify(userObject));
      localStorage.setItem('token', token);

      login(userObject, token);

      message.success('Uspešna prijava!');
      navigate(from, { replace: true });
    }

    setLoading(false);
  };

  return (
    <div className={styles.login}>
      <div className={styles.login__center}>
        <Card className={styles.login__card}>
          <div className={styles.login__card__imageContainer}>
            <img width={136} height={136} src="/logo.svg" />
          </div>

          <Form layout="vertical" onFinish={handleLogin}>
            <div style={{ marginBottom: '24px' }}>
              <Input
                label="Adresa e-pošte"
                type="email"
                name="email"
                id="email"
                placeholder="Adresa e-pošte"
                autoComplete="new-email"
                value={form.email}
                onChange={(e) => handleOnChange(e)}
              />
            </div>

            <div>
              <Input
                label="Lozinka"
                type="password"
                name="password"
                id="password"
                placeholder="Lozinka"
                autoComplete="new-password"
                value={form.password}
                onChange={(e) => handleOnChange(e)}
              />
            </div>

            <Button
              type="link"
              href="/zaboravljena-sifra"
              className={styles.login__forgotPassword}
            >
              Zaboravili ste šifru?
            </Button>

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}

            <Form.Item className={styles.login__submit}>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
                className="btn-primary login-btn"
              >
                Uloguj se
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
